import { AND_CONDITION, OR_CONDITION } from './constants'

/**
 * Base class for all query builders
 */
export class QueryBuilderBase {

  constructor(operator, query) {
    this.operator = operator;
    this.query = query;
  }

  /**
   * Given the operators as an object, convert to an array;
   * [
   *   {
   *     name: 'more than x days ago',
   *     isRelative: true,
   *     needIntegerValue: true,
   *   },
   *   {
   *     name: 'within the last x days',
   *     isRelative: true,
   *     needIntegerValue: true,
   *   },
   *   {
   *     name: 'yesterday',
   *     isRelative: true,
   *   },
   *   etc...
   * ]
   *
   * @return  {array}
   */
  static get OperatorList() {
    return Object.keys(this.Operators).map(key => {
      return {
        ...this.Operators[key],
      };
    });
  }

  /**
   * Get an array of operator names only:
   * ['is greater than', 'is less than', ...]
   *
   * @return  {array} operator names
   */
  static get OperatorNames() {
    return Object.keys(this.Operators).map(key => this.Operators[key].name);
  }

  /** Check if this operator is in the list of allowed */
  HasOperator() {
    return this.constructor.OperatorNames.includes(this.operator);
  }

  QueryObject(fieldName, operands = [], conditionType, index) {
    if (!this.HasOperator()) return;

    if (!this.buildCondition) return;

    const condition = this.buildCondition(fieldName, operands, this.operator);
    if (!condition) return this.query; // Return early if condition is null
  
    const queryKey = `$${conditionType}`.toLowerCase();
  
    if (index === 0) {
      this.query = { ...condition };
    } else if (index === 1) {
      this.query = { [queryKey]: [{ ...this.query }, { ...condition }] };
    } else {
      if (conditionType === AND_CONDITION && this.query.$or) {
        const andConditionInOr = this.query.$or.find(cond => cond.$and);
        if (!andConditionInOr) {
          this.query.$or.push({ $and: [condition] });
        } else {
          andConditionInOr.$and.push(condition);
        }
      } else if (conditionType === OR_CONDITION) {
        if (!this.query.$or) {
          this.query.$or = [];
          if (this.query.$and) {
            this.query.$or.push({ $and: [...this.query.$and] });
            delete this.query.$and;
          }
        }
        this.query.$or.push(condition);
      } else {
        this.query.$and = this.query.$and || [];
        this.query.$and.push(condition);
      }
    }
  
    return this.query;
  }

}
